import { Paper, styled, Typography, Box } from "@mui/material";
const CustomPaper = styled(Paper)({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px",
  gap: "8px",
  width: "501px",
  height: "120px",
  background: "#F6F6F6",
  boxShadow: "none",
  borderRadius: "4px",
});

const SubHeadings = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
  lineHeight: "140%",
  display: "flex",
  alignItems: "center",
  textAlign: "center",
  letterSpacing: "0.015em",
  color: "#1A1824",
});

const RateHeading = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "28px",
  lineHeight: "125%",
  textAlign: "center",
  letterSpacing: "0.01em",
  color: "#000000",
  // border:"1px solid red"
});

const LightTitle = styled(Typography)({
  fontFamily: "Outfit",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "160%",
  letterSpacing: "0.015em",
  color: " #9EA3AE",
});

const HighLightedCard = ({ price }) => {
  return (
    <CustomPaper>
      <Box>
        <SubHeadings>Your refund amount</SubHeadings>
        <LightTitle>
          The refund amount has been deducted by 10% for admin fees
        </LightTitle>
      </Box>
      <RateHeading>$ {price - price * 0.1}.00</RateHeading>
    </CustomPaper>
  );
};

export default HighLightedCard;
